const fixedInputClass="rounded-md appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-sky-500 focus:border-sky-500 focus:z-10 sm:text-sm"

export default function Input({
    handleChange,
    value,
    labelText,
    labelFor,
    id,
    name,
    type,
    isRequired=false,
    placeholder,
    customClass,
    disabled,
}){
    return(
        <div className="mb-5">
            <label htmlFor={labelFor} className="sr-only">
              {labelText}
            </label>
            <input
              onChange={handleChange}
              value={value}
              id={id}
              name={name}
              type={type}
              required={isRequired}
              className={fixedInputClass+customClass}
              placeholder={placeholder}
              disabled = {disabled}
            />
          </div>
    )
}

export function Textarea({
  handleChange,
  value,
  labelText,
  labelFor,
  id,
  name,
  type,
  isRequired=false,
  placeholder,
  customClass,
  rol
}){
  return(
      <div className="mb-5 mt-0">
          <label htmlFor={labelFor} className="sr-only">
            {labelText}
          </label>
          <textarea
            onChange={handleChange}
            value={value}
            id={id}
            name={name}
            type={type}
            required={isRequired}
            className={fixedInputClass+customClass}
            placeholder={placeholder}
            rows={rol}
          />
        </div>
  )
}

export function Select({
  handleChange,
  value,
  id,
  customClass,
  options
}){
  return(
      <div className="mb-5 mt-0">
         <select value={value} onChange={handleChange} className={fixedInputClass+customClass} id={id}>
            {
              options.map((opt)=>(
                <option value={opt.value}>{opt.label}</option>
              ))
            }
         </select>
        </div>
  )
}